import React from 'react';
import { LuMoon, LuSun } from 'react-icons/lu';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Light / dark switch shown as two labelled buttons, so it is clear which mode is on.
 */
const ThemeToggle = ({ className = '' }) => {
  const { theme, setTheme } = useTheme();

  const options = [
    { value: 'light', label: 'Light', icon: LuSun },
    { value: 'dark', label: 'Dark', icon: LuMoon },
  ];

  return (
    <div role="radiogroup" aria-label="Appearance" className={`inline-flex rounded-lg bg-ui-muted p-0.5 ring-1 ring-ui-line ${className}`}>
      {options.map((option) => {
        const Icon = option.icon;
        const isSelected = theme === option.value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={isSelected}
            onClick={() => setTheme(option.value)}
            className={`flex h-7 items-center gap-1.5 rounded-md px-2.5 text-xs font-medium transition-colors ${
              isSelected ? 'bg-ui-card text-ui-ink shadow-sm' : 'text-ui-ink-3 hover:text-ui-ink'
            }`}
          >
            <Icon aria-hidden className="size-3.5" />
            {option.label}
          </button>
        );
      })}
    </div>
  );
};

export default ThemeToggle;
